import { dataPasteImageSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPasteImageSolid = /*#__PURE__*/createIcon(dataPasteImageSolid)
export default IconPasteImageSolid
